import ApiClient from './ApiClient';

class PaymentsAPI extends ApiClient {
  constructor() {
    super('payment_dashboards', { accountScoped: true });
  }
  makepayment(statusObj) {
    const updatedUrl = this.url.replace('/payment_dashboards', '');
    console.log("My STatus Object",statusObj,this.url);
    return axios.post(`${updatedUrl}/payments`, statusObj);
  }
  fetchallagent() {
    // const updatedUrl = this.url.replace('/pipelines', '/');
    console.log("My STatus Object",this.url);
    return axios.get(`${this.url}/fetch_all_agents`);
  }
  // paymentfilter(statusObj) {
  //   // const updatedUrl = this.url.replace('/payment_dashboards', '/');
  //   console.log("My STatus Object",statusObj,this.url);
  //   return axios.post(`${this.url}/filter_data`, statusObj);
  // }
  paymentfilter(statusObj) {
    const isCSV = statusObj?.csv === true;
    // let query = '';
    // if (key && value) query += `&${key}=${value}`;
    // return axios.post(`${this.url}/filter_data`, statusObj, {
    //   responseType: isCSV ? 'blob' : 'json' // 👈 handle CSV as blob
    // });
    const { key, value, ...postData } = statusObj;

  // Build query only if key and value are provided
  let query = '';
  if (key && value) {
    query = `?${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  }

  return axios.post(`${this.url}/filter_data${query}`, postData, {
    responseType: isCSV ? 'blob' : 'json'
  });
  }
  
  graphview(statusObj) {
    // const updatedUrl = this.url.replace('/payment_dashboards', '/');
    console.log("My STatus Object",statusObj,this.url);
    return axios.get(`${this.url}/graph_view`, statusObj);
  }
  paymentcategories() {
    // const updatedUrl = this.url.replace('/pipelines', '/');
    console.log("My STatus Object",this.url);
    return axios.get(`${this.url}/fetch_all_categories`);
  }
  allpayment() {
    // const updatedUrl = this.url.replace('/pipelines', '/');
    console.log("My STatus Object",this.url);
    return axios.get(`${this.url}`);
  }
  allpaymentContactList(data){
    const { key, value}=data;
    let query = '';
    // query+=`page=1`;
    if (key && value) query += `${key}=${value}`;
    const updatedUrl = this.url.replace('/payment_dashboards', '');
    console.log("My STatus Object",data,this.url);
    return axios.get(`${updatedUrl}/payments/contact?${query}`, data);
  }
}

export default new PaymentsAPI();